module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.b26659fd.png";